import { takeEvery, call, put } from 'redux-saga/effects';

import { AsyncStorage } from '@formue-app/core';

import { actions as appActions } from '../../app/actions';
import { actions } from './actions';

const DISMISSABLE_WHITELIST = [
  'dismissedAppPromotion',
  'dismissedPasskeysOnboarding',
  'dismissedReportingPromotion',
  'dismissedRealAssetsPromotion',
  'dismissedReferralCampaign',
  'dismissedReferralPromotion',
];

function* hydrateDismissed() {
  yield takeEvery(appActions.init, function* () {
    const storedKeys = yield call(AsyncStorage.getAllKeys);
    const dismissedKeys = storedKeys.filter(
      (key) =>
        key.startsWith('dismissed') && DISMISSABLE_WHITELIST.includes(key)
    );

    if (dismissedKeys.length > 0) {
      for (const key of dismissedKeys) {
        yield put(actions.setDismissed(key));
      }
    }
  });
}

function* dismiss() {
  yield takeEvery(actions.dismiss, function* ({ payload }) {
    if (!DISMISSABLE_WHITELIST.includes(payload)) {
      console.error(
        `Unknown dismissible key: ${payload}. Add key to DISMISSABLE_WHITELIST`
      );
    } else {
      yield call(AsyncStorage.setItem, payload, new Date().toISOString());
      yield put(actions.setDismissed(payload));
    }
  });
}

export const sagas = [dismiss, hydrateDismissed];
